import { render, staticRenderFns } from "./AccountBenefitList.vue?vue&type=template&id=07f61f24&"
import script from "./AccountBenefitList.vue?vue&type=script&lang=js&"
export * from "./AccountBenefitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports